// extracted by css-extract-rspack-plugin
export default {"zaggle-delivery-address-readonly":"zaggle-delivery-address-readonly-QJ6vwz","zaggleDeliveryAddressReadonly":"zaggle-delivery-address-readonly-QJ6vwz"};